import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CoxService } from 'src/app/app-business-object-module/cox.service';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-shipment-history-v2',
    templateUrl: './shipment-history-v2.component.html',
    styleUrls: ['./shipment-history-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShipmentHistoryV2Component implements OnInit {

  @Input() configData;
  @Input() frmGroup;

  history = [];
  expectValues = [];
  isLoading: boolean = false;

  constructor(private coxService: CoxService) { }

  ngOnInit(): void {
    this.history = this.frmGroup.get(this.configData.name).value?.history || [];
    this.history.sort((a, b) => (a.capturedAt < b.capturedAt) ? 1 : -1); //NCP - 10364

    //NCP-10552 - start
    if (localStorage.getItem("userRole") === "ClientExternalUser" || localStorage.getItem("userRole") === "ClientExternalUserCommercial") {
      this.history = this.history.filter((element) => {
        if (element['historyType'] === "reschedule") {
          return element;
        }
      })
    }
    //NCP-10552 - end

    this.expectValues = ["historyType", "subType", "shipmentId", "loadId", "capturedAt", "displayDateTime", "historyTypeText", "status", "UUID"];

    this.history.forEach((element) => {
      element["historyTypeText"] = element["historyType"].charAt(0).toUpperCase();

      //NCP- 10500 - start
      if(element["historyType"]==="tender-offer" && element["status"].toLowerCase()==="active"){        
        if(element["offerExpiryDate"] && new Date(element["offerExpiryDate"].split("T")[0]) < new Date(new Date().toISOString().split("T")[0])){
          element["status"] = "Expired";
        }
      }
      //NCP- 10500 - end
      
      let displayData = [];
      Object.keys(element).forEach((key) => {
        if (!this.expectValues.includes(key)) {
          if (key.toLowerCase().includes('date') && element[key] && (new Date(element[key]) instanceof Date)) {
            displayData.push({ key: this.getFormatedKey(key), value: new Date(element[key].replace("Z", "")).toLocaleDateString() }); //NCP - 10364  
          }
          else {
            displayData.push({ key: this.getFormatedKey(key), value: element[key] });
          }
        }
      });
      element["displayData"] = displayData;
    });
  }

  getFormatedKey(key) {
    return this.coxService.separatePascalCase(key)
  }

  getColsClass(cols: number[], control?: any) {
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for (let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }
    if (control && navigator.userAgent.toLowerCase().indexOf("mobile") > -1) {   // hard coded
      if (control && control["component"] == "SEARCHBOX_V2" && control["name"] == "SearchBox") {
        colsClass += "makeDwarf searchBoxMobileView";
      }
      if (control && control["component"] == "FORM_FILTER_V2" && control["name"] == "formFilter") {
        colsClass += "makeDwarf formFilterMobileView";
      }
    }
    if (control && control.hasOwnProperty("makeDwarf") && control.makeDwarf) {
      colsClass += 'dwarf' + ' ';
    }
    return colsClass;
  }

}
